import { useQuery } from '@tanstack/react-query';
import { staffKeys, type StaffListQuery } from '@/services/queryKeys';
import { staffService } from '@/services/staff.service';
import type { TenantStaff } from '@/mocks/staffs';

/**
 * TCR-1746 — chỉ hiện tên khiến admin không phân biệt được 2 nhân viên
 * trùng/gần giống tên (vd "Dương Quỳnh Hoa" và "Dương Quỳnh Hoa B2B" là 2
 * người khác nhau). Ghép thêm mã NV + SĐT vào label — data đã có sẵn trong
 * `TenantStaff` (không cần gọi thêm API). Dùng CHUNG cho mọi nơi hiển thị tên
 * nhân viên phụ trách (AssignSaleModal — cả dropdown option lẫn chip đã chọn
 * — và CustomerDetailPage — chip tĩnh "NVKD phụ trách") để 2 nơi không lệch
 * nhau như bug gốc của TCR-1746 (modal đã ghép mã NV/SĐT, chip tĩnh ở trang
 * chi tiết lại tra tên qua đường khác và bị bỏ sót).
 */
export function buildStaffDisplayLabel(staff: Pick<TenantStaff, 'name' | 'staff_code' | 'phone'>): string {
  const parts = [staff.name];
  if (staff.staff_code) parts.push(`(${staff.staff_code})`);
  if (staff.phone) parts.push(`- ${staff.phone}`);
  return parts.join(' ');
}

export function useStaffList(query: StaffListQuery) {
  return useQuery({
    queryKey: staffKeys.list(query),
    queryFn: () => staffService.list(query),
    placeholderData: (prev) => prev,
    retry: 0,
  });
}

/** Toàn bộ tài khoản ERP (ghép nhiều trang) — dùng cho ô chọn có tìm kiếm tại chỗ. */
export function useAllStaffUsers(enabled = true) {
  return useQuery({
    queryKey: ['staff', 'all-pages'],
    queryFn: () => staffService.listAll(),
    enabled,
    retry: 0,
  });
}
